import ModalWrapper from "../../modalWrapper/ModalWrapper";
import { BaseTable } from "../../UI/baseTable/BaseTable";
import { StatusChip } from "../../statusChip/StatusChip";
import { useSelector } from "react-redux";
import { useTranslations } from "../../../helperFunctions/customHooks/useTranslations";

export function HistoryScheduled({ onClick }) {
  const { t } = useTranslations();

  const { status, deliveries } = useSelector(
    (state) => state.scheduledDeliveries.getCreatedScheduledById
  );

  const columns = [
    { label: t.deliveries.table.order },
    { label: t.deliveries.table.customer },
    { label: t.deliveries.table.pickupAddress },
    { label: t.deliveries.table.dropoffAddress },
    { label: t.deliveries.table.date },
    { label: t.deliveries.table.driver },
    { label: t.deliveries.table.status },
  ];

  return (
    <ModalWrapper
      title={t.deliveries.scheduledTitle}
      onClick={onClick}
      width="950px"
      style={{ minHeight: "500px" }}
      headerWidth="100%"
    >
      <BaseTable
        resultsContainerHeight={"470px"}
        containerWidth={"100%"}
        tableStyle={{ padding: "0", margin: "0" }}
        status={status}
        errorMsg={t.deliveries.errorFetchingData}
        noItemsMsg={t.deliveries.noDeliveriesFound}
        items={deliveries}
        columns={columns}
        columnAndRowWidth={"130px"}
        rows={
          deliveries &&
          deliveries?.map((item) => [
            item.created_delivery_id,
            item.customer_name,
            item.pickup_address,
            item.dropoff_address,
            item.p_order_date,
            item.driver_name ? item.driver_name : t.deliveries.noDriver,
            <StatusChip status={item.p_status_name} />,
          ])
        }
      />
    </ModalWrapper>
  );
}
